import {
  emailOTPClient,
  inferAdditionalFields,
} from "better-auth/client/plugins"
import { createAuthClient } from "better-auth/solid"
import { browserLocale, localeFromUrl } from "./i18n"

const additionalUserFields = {
  user: {
    onboarding_stage: { type: "string", required: false },
    locale: { type: "string" },
    interface_locale: { type: "string" },
    author_name: { type: "string", required: false },
  },
} as const

function createClient() {
  const locale = localeFromUrl() ?? browserLocale()

  return createAuthClient({
    callbackURL: import.meta.env.VITE_FIKA_CLIENT_URL,
    baseURL: import.meta.env.VITE_FIKA_CLIENT_URL,
    plugins: [emailOTPClient(), inferAdditionalFields(additionalUserFields)],
    fetchOptions: {
      headers: {
        "X-User-Locale": locale,
      },
    },
  })
}

let client: ReturnType<typeof createClient>

export function betterAuthClient() {
  if (client) return client

  client = createClient()

  return client
}
